import { render, staticRenderFns } from "./TestKitSeeResult.vue?vue&type=template&id=c2cbe988&scoped=true&"
import script from "./TestKitSeeResult.vue?vue&type=script&lang=js&"
export * from "./TestKitSeeResult.vue?vue&type=script&lang=js&"
import style0 from "./TestKitSeeResult.vue?vue&type=style&index=0&id=c2cbe988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cbe988",
  null
  
)

export default component.exports